import $ from "cash-dom";
import anime from "animejs/lib/anime.es.js";

export const anchorScrollComponent = (root = document) => {
    const targets = window.document.scrollingElement || window.document.body || window.document.documentElement;
    if (window.location.hash) {
        // targets.scrollTop = 0;
        setTimeout(() => {
                anime({
                    targets,
                    scrollTop: $(window.location.hash).offset().top,
                    duration: 500,
                    easing: 'easeInSine',
                });
            },
            250
        );
    }

    $(root).find('a[href^="#"]').each((_, a) => {
        const href = a.getAttribute('href');
        // console.log(href);

        const target = $(`#${href.split('#')[1]}`);

        a.addEventListener('click', e => {
            e.preventDefault();

            anime({
                targets,
                scrollTop: target.offset().top,
                duration: 500,
                easing: 'easeInSine',
            });
        });
    });
};
